package org.vreo.devicehub.features.userAuthentication.presentation.verification

import org.vreo.devicehub.features.core.presentation.UiText

/**
 * Account verification state
 */
data class AccountVerificationState(
    val isLoading: Boolean = false,
    val error: UiText? = null,

    val userEmail: String = "",
    val validUntilMs: Long? = null,
    val verificationCode: String = "",
)